/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustLocationSkuItem
 */
export interface AdminStockAdjustLocationSkuItem {
    /**
     * SKU主键ID
     * @type {number}
     * @memberof AdminStockAdjustLocationSkuItem
     */
    skuId?: number;
    /**
     * SKU编码
     * @type {string}
     * @memberof AdminStockAdjustLocationSkuItem
     */
    skuCode?: string;
    /**
     * 主图
     * @type {string}
     * @memberof AdminStockAdjustLocationSkuItem
     */
    imageUrl?: string;
    /**
     * 箱内可用数量（不含冻结）
     * @type {number}
     * @memberof AdminStockAdjustLocationSkuItem
     */
    quantity?: number;
    /**
     * 商品批次 goodsId
     * @type {number}
     * @memberof AdminStockAdjustLocationSkuItem
     */
    goodsId?: number;
    /**
     * 订单编号(批次)
     * @type {string}
     * @memberof AdminStockAdjustLocationSkuItem
     */
    orderCode?: string;
    /**
     * 包装规格(cm)
     * @type {string}
     * @memberof AdminStockAdjustLocationSkuItem
     */
    packageSpecCm?: string;
    /**
     * 单个CBM
     * @type {number}
     * @memberof AdminStockAdjustLocationSkuItem
     */
    singleCbm?: number;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationSkuItem interface.
 */
export function instanceOfAdminStockAdjustLocationSkuItem(value: object): value is AdminStockAdjustLocationSkuItem {
    return true;
}

export function AdminStockAdjustLocationSkuItemFromJSON(json: any): AdminStockAdjustLocationSkuItem {
    return AdminStockAdjustLocationSkuItemFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationSkuItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationSkuItem {
    if (json == null) {
        return json;
    }
    return {
        
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'packageSpecCm': json['packageSpecCm'] == null ? undefined : json['packageSpecCm'],
        'singleCbm': json['singleCbm'] == null ? undefined : json['singleCbm'],
    };
}

export function AdminStockAdjustLocationSkuItemToJSON(json: any): AdminStockAdjustLocationSkuItem {
    return AdminStockAdjustLocationSkuItemToJSONTyped(json, false);
}

export function AdminStockAdjustLocationSkuItemToJSONTyped(value?: AdminStockAdjustLocationSkuItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'imageUrl': value['imageUrl'],
        'quantity': value['quantity'],
        'goodsId': value['goodsId'],
        'orderCode': value['orderCode'],
        'packageSpecCm': value['packageSpecCm'],
        'singleCbm': value['singleCbm'],
    };
}

